import { rollbar } from '@/helpers/rollbar';

// Some in-app browsers/WebViews (e.g. QR scanner previews, WebViews without
// DOM storage enabled) expose `window.localStorage` as null or throw when
// it's accessed, instead of just being unsupported. Guard every access so a
// missing/blocked localStorage doesn't crash the app.
let warned = false;
const warnUnavailable = (reason) => {
  if (warned) return;
  warned = true;
  rollbar.warn('localStorage unavailable', {reason, userAgent: navigator.userAgent});
};

const isStorageAvailable = () => {
  try {
    if (!window.localStorage) {
      warnUnavailable('window.localStorage is null/undefined');
      return false;
    }
    return true;
  } catch (e) {
    warnUnavailable(e.message);
    return false;
  }
};

export const storage = {
  getItem: (key) => {
    if (!isStorageAvailable()) return null;
    try {
      return window.localStorage.getItem(key);
    } catch (e) {
      warnUnavailable(e.message);
      return null;
    }
  },
  setItem: (key, value) => {
    if (!isStorageAvailable()) return;
    try {
      window.localStorage.setItem(key, value);
    } catch (e) {
      warnUnavailable(e.message);
    }
  },
  removeItem: (key) => {
    if (!isStorageAvailable()) return;
    try {
      window.localStorage.removeItem(key);
    } catch (e) {
      warnUnavailable(e.message);
    }
  },
};
